import { Mapper } from '../services/mapper.service'

import { MappableModel } from './mappable-model'
import { Waiver } from './waiver'
import { ValidationRules } from './validation-rules'
import { Tag } from './tag'
import { Organization } from './organization'
import { AdditionalFields } from './additional-fields'
import { ElectronicDocument } from './electronic-document'

export enum MembershipEffectiveType {
  Duration = 'duration',
  Lifetime = 'lifetime',
  PickADate = 'pick_a_date',
  Termed = 'termed',
}

class MembershipDefinitionLink extends MappableModel {
  public id: string
  public parent_membership_definition_id: string
  public child_membership_definition_id: string
  public parent_membership_definition_name: string
  public child_membership_definition_name: string
  public parent_membership_definition_org_id: number
  public child_membership_definition_org_id: number
}

export class MembershipDefinition extends MappableModel {
  public boss_organization_id: number
  public can_affiliate_obo: boolean
  public can_direct: boolean
  public can_invite: boolean
  public clare_item_uuid: string
  public credential_definition_ids: number[]
  public description: string
  public duration_type: string
  public duration_value: number
  public effective_type: MembershipEffectiveType
  public electronic_documents: ElectronicDocument[]
  public end_date: Date
  public id: string
  public membership_assignment_type: string
  public membership_count: number
  public merged_additional_fields: string[]
  public merged_validation_rules: string[]
  public name: string
  public organization: Organization
  public price_cents: number
  public purchase_status: string
  public start_date: Date
  public tags: Tag[]
  public waivers: Waiver[]
  public validation_rules: string[]
  public parent_membership_definition_links: MembershipDefinitionLink[]
  public child_membership_definition_links: MembershipDefinitionLink[]

  public get price(): number {
    return this.price_cents / 100
  }

  public deserialize(): void {
    this.start_date = this.start_date ? new Date(this.start_date) : null
    this.end_date = this.end_date ? new Date(this.end_date) : null
    this.parent_membership_definition_links = Mapper.asArray<MembershipDefinitionLink>(
      this.parent_membership_definition_links, MembershipDefinitionLink
    )
    this.child_membership_definition_links = Mapper.asArray<MembershipDefinitionLink>(
      this.child_membership_definition_links, MembershipDefinitionLink
    )
    this.tags = this.tags ? Mapper.asArray<Tag>(this.tags, Tag) : []
    this.organization = this.organization ? Mapper.as<Organization>(this.organization, Organization) : null
  }

  public get duplicateMembershipsAllowed(): boolean {
    return (this.membership_assignment_type || '').startsWith('allow_')
  }

  public get isPickADate(): boolean {
    return this.effective_type === MembershipEffectiveType.PickADate
  }

  public get unapprovedDuplicateMembershipsAllowed(): boolean {
    return (this.membership_assignment_type || '').startsWith('allow_unapproved_')
  }

  public get hasParentMembershipDefinitions(): boolean {
    return this.parent_membership_definition_links && this.parent_membership_definition_links.length > 0
  }

  public get approvedDuplicateMembershipsAllowed(): boolean {
    return this.duplicateMembershipsAllowed && !this.unapprovedDuplicateMembershipsAllowed
  }

  public get isPublished(): boolean {
    return this.purchase_status === 'published'
  }

  public getValidationRules(): ValidationRules {
    return new ValidationRules(this.merged_validation_rules)
  }

  public getAdditonalFields(): AdditionalFields {
    return new AdditionalFields(this.merged_additional_fields)
  }
}
